import { Directive } from "@angular/core";

/**
 * Wrapper for list action controls in a mat-card.
 * Provides consistent spacing and alignment for list management buttons.
 *
 * @example
 * <mat-card>
 *   <mgd-card-list-actions>
 *     <button mat-raised-button>Add New</button>
 *     <span>5 items selected</span>
 *   </mgd-card-list-actions>
 * </mat-card>
 */
@Directive({
    selector: "mgd-card-list-actions",
    host: {
        class: "mgd-card-list-actions"
    }
})
export class CardListActionsDirective {}
